export default __webpack_public_path__ + "static/media/rest-assured.1f017b48.png";